import { render, staticRenderFns } from "./micoapp_violations.vue?vue&type=template&id=2549111a"
import script from "./micoapp_violations.vue?vue&type=script&lang=js"
export * from "./micoapp_violations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports